import React from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import 'react-toastify/dist/ReactToastify.css';

const Return = () => {


    return (
        <div className='dark:text-white dark:bg-black'>
            <Navbar />
            <section className="text-gray-600 body-font relative dark:text-white">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-col text-center w-full mb-20">
                        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 dark:text-white text-gray-900">Return Policy</h1>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            Orders delivered & accepted by the customer cannot be refunded.</p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            In case you feel the order is not as per specification, please contact our customer care team immediately in 24hrs.</p><br></br>
                        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 dark:text-white text-gray-900">Cancellation Policy</h1>


                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            Go-Green believes in helping its customers as far as possible and has, therefore, a liberal cancellation policy. Under this policy:</p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            Cancellations will be considered only if the request is made within 24 hours of placing an order. However, the cancellation request will not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them. </p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            There is no cancellation of orders placed under the Same Day Delivery category. </p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            No cancellations are entertained for those products that the Go-Green marketing team has obtained on special occasions like Pongal, Diwali, Valentine’s Day etc. These are limited occasion offers and therefore cancellations are not possible. </p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            In case of receipt of damaged or defective consumer durable items and nondurable items, please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 1 day of receipt of the products.  </p>

                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                            In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 24 hours of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision. </p>
                    </div>
                </div>
            </section>
            <SmallFooter />
        </div>
    )
}

export default Return